import type { IconNode } from '../types';

/**
 * @name bear-face
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNiA3IC41LjUiIC8+CiAgPHBhdGggZD0ibTE4IDctLjUuNSIgLz4KICA8cGF0aCBkPSJNMjAuOCA0LjJjLTEuNi0xLjYtNC4xLTEuNi01LjcgMGwtMSAxYTEzLjYgMTMuNiAwIDAgMC00LjIgMGwtMS0xYTQgNCAwIDAgMC01LjggNS41NUE3IDcgMCAwIDAgMiAxMy41QzIgMTguMiA2LjUgMjIgMTIgMjJzMTAtMy44IDEwLTguNWE3IDcgMCAwIDAtMS4xLTMuOGMxLjUtMS42IDEuNS00LS4xLTUuNSIgLz4KICA8cGF0aCBkPSJNMTAgMTJ2LS41IiAvPgogIDxwYXRoIGQ9Ik0xNCAxMnYtLjUiIC8+CiAgPHBhdGggZD0iTTE0IDE2aC00IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNnYyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bear-face
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bearFace: IconNode = [
  ['path', { d: 'm6 7 .5.5', key: '1mues1' }],
  ['path', { d: 'm18 7-.5.5', key: '1hegvp' }],
  [
    'path',
    {
      d: 'M20.8 4.2c-1.6-1.6-4.1-1.6-5.7 0l-1 1a13.6 13.6 0 0 0-4.2 0l-1-1a4 4 0 0 0-5.8 5.55A7 7 0 0 0 2 13.5C2 18.2 6.5 22 12 22s10-3.8 10-8.5a7 7 0 0 0-1.1-3.8c1.5-1.6 1.5-4-.1-5.5',
      key: '10jti9',
    },
  ],
  ['path', { d: 'M10 12v-.5', key: 'r6sbf9' }],
  ['path', { d: 'M14 12v-.5', key: 'soy5sh' }],
  ['path', { d: 'M14 16h-4', key: 'l5u338' }],
  ['path', { d: 'M12 16v2', key: 'z66u1j' }],
];

export default bearFace;
